import { useLayoutEffect, useRef, useState } from "react";

interface Option<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  options: Option<T>[];
  value: T;
  onChange: (v: T) => void;
  className?: string;
}

/** PL segmented control con thumb animato. */
export function Segmented<T extends string>({
  options,
  value,
  onChange,
  className = "",
}: Props<T>) {
  const wrapRef = useRef<HTMLDivElement>(null);
  const [thumb, setThumb] = useState<{ left: number; width: number }>({
    left: 3,
    width: 0,
  });

  useLayoutEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return;
    const idx = options.findIndex((o) => o.value === value);
    const btn = wrap.querySelectorAll<HTMLButtonElement>(".seg-btn")[idx];
    if (!btn) return;
    setThumb({ left: btn.offsetLeft, width: btn.offsetWidth });
  }, [value, options]);

  return (
    <div ref={wrapRef} className={`seg ${className}`}>
      <div
        className="seg-thumb"
        style={{ left: `${thumb.left}px`, width: `${thumb.width}px` }}
      />
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={`seg-btn ${o.value === value ? "active" : ""}`}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
